jQuery(($) => {
    function main () {
        setupDatePickers();
        setupCheckboxes();

        const queryStringObject = new URLSearchParams(window.location.search);
        getList(queryStringObject);
    }

    function setupDatePickers () {
        document.querySelectorAll('.datepickerStart').forEach(element => {
            element.addEventListener('input', setStartDate);
            element.addEventListener('change', setStartDate);
            element.addEventListener('blur', setStartDate);
        });

        function setStartDate (e) {
            const queryStringObject = new URLSearchParams(window.location.search);
            const startDate = queryStringObject.set('startDate', e.currentTarget.value);

            getList(queryStringObject);

            const isStartDate = queryStringObject.get('startDate');

            if (isStartDate !== null) {
                document.querySelector('.datepickerEnd').setAttribute('min', startDate);
            } else {
                document.querySelector('.datepickerEnd').setAttribute('min', '');
            }
        }

        document.querySelectorAll('.datepickerEnd').forEach(element => {
            element.addEventListener('input', setEndDate);
            element.addEventListener('change', setEndDate);
            element.addEventListener('blur', setEndDate);
        });

        function setEndDate (e) {
            const queryStringObject = new URLSearchParams(window.location.search);
            const endDate = queryStringObject.set('endDate', e.currentTarget.value);

            getList(queryStringObject);

            const isEndDate = queryStringObject.get('endDate');

            if (isEndDate !== null) {
                document.querySelector('.datepickerStart').setAttribute('max', endDate);
            } else {
                document.querySelector('.datepickerStart').setAttribute('max', '');
            }
        };

        $('.hasDatepicker').keyup(function (e) {
            if (e.keyCode === 8 || e.keyCode === 46) {
                $.datepicker._clearDate(this);
            }
        });

        $('.hasDatepicker').keydown(e => false);
    }

    function getList (queryStringObject) {
        const tags = selectedType().join(',');

        if (tags.length > 0) {
            queryStringObject.set('tagId', tags);
        } else {
            queryStringObject.delete('tagId');
        }

        if (queryStringObject.get('startDate') === '') {
            queryStringObject.delete('startDate');
        }

        if (queryStringObject.get('endDate') === '') {
            queryStringObject.delete('endDate');
        }

        $('.all-ajax-list').hide();
        $('.pagination').hide();
        $('.ajax-loader').show();

        const loadingAnnouncement = document.createElement('span');
        loadingAnnouncement.setAttribute('class', 'sr-only');
        loadingAnnouncement.setAttribute('role', 'status');
        loadingAnnouncement.textContent = 'Searching, please wait';
        const loadingAnnouncementTimeout = setTimeout(function () { $('.ajax-loader').append(loadingAnnouncement); }, 500);

        const queryString = queryStringObject.toString();

        let url = `${window.location.origin}${window.location.pathname}`;

        if (queryString !== '') {
            url += `?${queryString}`;
        }

        $.ajax({
            type: 'GET',
            url,
            dataType: 'html'
        }).success((data) => {
            $('.ajax-loader').hide();
            $('.all-ajax-list').show();
            $('.pagination').show();
            $('.ajax-list-holder').html(data);

            clearTimeout(loadingAnnouncementTimeout);

            if (typeof window.history !== 'undefined') {
                window.history.pushState(
                    { url },
                    document.title,
                    url
                );
            }
        });
    }

    function setupCheckboxes () {
        $('input[id^="select-all"]').change(function () {
            const cell = $(this).parents(':eq(1)').siblings().find('.checkbox');
            cell.prop('checked', $(this).prop('checked'));

            const queryString = new URLSearchParams(window.location.search);
            getList(queryString);
        });

        $('.sub-tag-checkbox').change(function () {
            const selectAll = $(this).parents(':eq(4)').children().children()
                .find('.select-all');

            if ($(this).prop('checked') === false && selectAll.length > 0) { // if this item is unchecked
                selectAll.prop('checked', false); // change "select all" checked status to false
            }

            const queryString = new URLSearchParams(window.location.search);
            getList(queryString);

            // check "select all" if all checkbox items are checked
            const childrenCheckbox = $(this).parents(':eq(2)').find('.checkbox');
            if ($('.checkbox:checked').length === childrenCheckbox.length) {
                selectAll.prop('checked', true);
            }
        });
    }

    function selectedType () {
        const result = [];

        $('.category:checkbox:checked').each(function () {
            result.push($(this).data('value'));
        });

        return result;
    }

    main();
});



// WEBPACK FOOTER //
// ./src/js/app/ajax-news.js